import React from 'react';

import { DropdownInput } from '../../../../Shared/index';

export default class ItemDropdown extends React.Component {
  constructor(props) {
    super(props)

    const { items, selectedItem } = props;
    const formattedItem = selectedItem ? this.formatItem(selectedItem) : this.formatItem((items[0]));

    this.state = { selectedItem: formattedItem }
  }

  formatItem = (item) => {
    if(typeof item === 'string') {
      return { label: item, value: item, }
    } else if(typeof item === 'object') {
      return { id: item.id ? item.id : null, label: item.name, value: item.id || item.name }
    }
  }

  items = () => {
    const { items } = this.props;
    return items.map(item => {
      return this.formatItem(item);
    });
  };

  findItemByIdOrName = (itemObject) => {
    const { items } = this.props;
    const { value, id, label, } = itemObject;

    return items.find((c) => {
      if (typeof c === 'string') {
        return c === value
      } else if (c.id) {
        return id === c.id
      } else {
        return label === c.name
      }
    });
  };

  onHandleSelect = (itemObject) => {
    const { callback } = this.props;
    const item = this.findItemByIdOrName(itemObject);
    this.setState({ selectedItem: this.formatItem(item)});
    if (callback) {
      callback(item);
    }
  };

  render() {
    const { selectedItem, } = this.state
    const { className, isSearchable, ariaLabel, } = this.props;
    return (
      <DropdownInput
        ariaLabel={ariaLabel}
        className={className ? `${className} focus-on-light` : "select-item-dropdown focus-on-light"}
        handleChange={this.onHandleSelect}
        isSearchable={isSearchable}
        options={this.items()}
        value={selectedItem}
      />
    );
  }
}
